module.exports = __webpack_public_path__ + "static/media/andritz-logo-icon.e506adc0.svg";